<div class="main-container">
  @let messages = threads()[currentThreadId()];
  @let contextExpandedMapVal = contextExpandedMap();
  @let hasMessages = messages?.()?.length;
  @if (hasMessages) {
    <div class="header">
      <rt-button variant="plain" size="small" (click)="onNewThread()">
        <rt-icon name="arrow-back" />
        {{ 'tlc.hr_assistant.new_thread' | translate }}
      </rt-button>
      <div class="name-container">
        <div class="name">
          <span text-small>{{ 'tlc.hr_assistant.hr_assistant' | translate }}</span>
          <div class="badge">{{ 'tlc.common.beta' | translate }}</div>
        </div>
      </div>
      <rt-icon-button size="small" iconName="close" variant="plain" (click)="onClose()" />
    </div>
    <div #messagesContainer class="messages-container">
      @for (message of messages(); track $index) {
        @let messageVal = message();
        @let isUser = messageVal.role === 'user';
        @let isAssistant = messageVal.role === 'assistant';
        <div class="item">
          <div class="message" [ngClass]="[messageVal.role]">
            @if (messageVal.isPending && isAssistant) {
              <div class="message--container">
                <p class="message--text shimmer">
                  {{ 'tlc.hr_assistant.searching_placeholder' | translate }}
                </p>
              </div>
            } @else {
              @if (isUser) {
                <rt-avatar
                  class="message--icon"
                  [type]="userAvatar() ? 'image' : 'initials'"
                  [imageSrc]="userAvatar()"
                  [initials]="userInitials()"
                  [fullName]="userFullName()"
                />
              } @else if (isAssistant) {
                <hr-assistant-icon class="message--icon" [size]="32" />
              }
              <div class="message--container">
                <p
                  class="message--text"
                  [innerHtml]="markdownToHtml | fnCall: messageVal.content"
                ></p>
                @if (isAssistant) {
                  @let contexts = getToolInvocationResultText | fnCall: messageVal.toolInvocations;
                  @let contextsExpanded = !!contextExpandedMapVal[messageVal.id];
                  @let visibleContexts =
                    contextsExpanded
                      ? contexts
                      : (contexts | slice: 0 : DEFAULT_MESSAGE_CONTEXT_COUNT);
                  @for (context of visibleContexts; track $index) {
                    <ng-template #tooltipTmpl>
                      <span
                        class="context--quote"
                        [innerHtml]="markdownToHtml | fnCall: context.text"
                      ></span>
                    </ng-template>
                    <div
                      class="context"
                      rtTooltip
                      [rtTooltipTemplate]="tooltipTmpl"
                      [rtTooltipMaxWidth]="381"
                    >
                      <a class="context--source" [href]="context.url" target="_blank">
                        <rt-icon name="notion" margin-right-small />
                        <rt-truncate class="truncate">{{ context.title }}</rt-truncate>
                        <rt-icon-button
                          iconName="open-in-new"
                          size="small-x"
                          variant="plain"
                          margin-left-small-x
                        />
                      </a>
                    </div>
                  }
                  @if (contexts.length > DEFAULT_MESSAGE_CONTEXT_COUNT) {
                    <rt-button
                      size="small"
                      variant="plain"
                      (click)="toggleExpandContext(messageVal.id)"
                      class="context-toggle"
                      margin-top-small
                    >
                      {{
                        (contextExpandedMapVal[messageVal.id]
                          ? 'tlc.hr_assistant.show_less'
                          : `tlc.hr_assistant.show_all_x`
                        )
                          | translate
                            : {
                                remainingCount: contexts.length - DEFAULT_MESSAGE_CONTEXT_COUNT,
                              }
                      }}
                    </rt-button>
                  }
                  <thumb-up-down-feedback class="actions" (feedbackChange)="onFeedback($event)" />
                }
              </div>
            }
          </div>
          @if (messageVal.isError) {
            <rt-infobox
              type="error"
              iconName="error"
              [isDismissible]="false"
              [buttons]="getMessageErrorButtons | fnCall: messageVal"
              margin-top-medium
            >
              <span>{{ 'tlc.hr_assistant.generic_error_msg' | translate }}</span>
            </rt-infobox>
          }
        </div>
      }
    </div>
  } @else {
    <div class="welcome-container">
      <div layout layout-space-between margin-bottom-large-x>
        <div class="welcome">
          <hr-assistant-icon [size]="40" margin-bottom-small />
          <div class="name-container">
            <div text-weight-semi-bold text-darkest>
              {{ 'tlc.hr_assistant.chat_header' | translate }}
            </div>
            <div class="badge" margin-left-small-x>{{ 'tlc.common.beta' | translate }}</div>
          </div>
          <p class="description" margin-top-small-xx text-color>
            {{ greeting() }}
          </p>
        </div>
        <rt-icon-button
          class="close-btn"
          size="small"
          iconName="close"
          variant="plain"
          (click)="onClose()"
        />
      </div>
      @if (conversationStarters().length) {
        <div>
          <div layout layout-align-items-center>
            <rt-heading> {{ 'tlc.hr_assistant.conversation_starters' | translate }} </rt-heading>
            <rt-badge
              [text]="conversationStarters().length"
              color="counter-default"
              margin-left-small-x
            />
          </div>
          <div class="starters">
            @for (starter of conversationStarters(); track starter.content) {
              <div class="starter" (click)="onStarterClick(starter.content)">
                @if (starter.symbol) {
                  <rt-symbol [symbol]="starter.symbol" text-primary margin-right-small-x />
                }
                {{ starter.content }}
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  <rt-divider />
  <div class="footer">
    <div class="text-area">
      <rt-textarea
        [formControl]="chatForm"
        [placeholder]="'tlc.hr_assistant.input_placeholder' | translate"
        (keyup.enter)="onSend()"
      />
      <div class="buttons">
        <rt-icon-button
          (click)="onSend()"
          class="send-button"
          iconName="arrow-upward"
          size="small"
          variant="primary"
        />
      </div>
    </div>
  </div>
</div>
